export default __webpack_public_path__ + "static/media/AdminBackground.abb03277.jpg";